
import React, { useState } from 'react';
import { Truck, Mail, Lock, LogIn, Loader2, ArrowLeft, AlertCircle, Database } from 'lucide-react';
import { db, hasValidSupabaseConfig } from './supabase.ts';

export const LoginPage = ({ onLogin, onBack }: { onLogin: (user: any) => void, onBack?: () => void }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;

    console.log("[LOGIN] handleLogin started");
    setLoading(true);
    setError('');

    try {
      console.log("[LOGIN] Calling db.signIn for:", email);
      const realUser = await db.signIn(email, password);
      
      if (!realUser) {
        console.warn("[LOGIN] db.signIn returned null (invalid credentials)");
        throw new Error("E-mail ou senha incorretos.");
      }

      console.log("[LOGIN] db.signIn success for:", realUser.email);
      onLogin(realUser);
    } catch (err: any) {
      console.error("[LOGIN] Error caught in handleLogin:", err);
      setError(err.message || 'Falha na autenticação.');
    } finally {
      console.log("[LOGIN] handleLogin finished (finally)");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary flex flex-col items-center justify-center p-6 relative overflow-hidden text-white">
      <div className="absolute top-[-20%] left-[-10%] w-[60%] h-[60%] bg-primary/20 rounded-full blur-[120px]"></div>
      
      {onBack && (
        <button 
          onClick={onBack}
          className="absolute top-8 left-8 flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-white/40 hover:text-white transition-colors group z-20"
        >
          <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" /> Voltar ao Site
        </button>
      )}

      <div className="w-full max-w-md z-10 space-y-8">
        <div className="text-center mb-10">
          <div className="inline-flex p-5 bg-primary rounded-[32px] text-white shadow-2xl shadow-primary/30 mb-6">
            <Truck size={48} strokeWidth={2.5} />
          </div>
          <h1 className="text-4xl font-black uppercase tracking-tighter">EventLog <span className="text-primary">PRO</span></h1>
          <p className="text-white/50 font-medium tracking-wide mt-2 italic">Infraestrutura Logística Master</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="bg-white/5 border border-white/10 p-2 rounded-[32px] backdrop-blur-xl">
            <div className="relative group">
              <Mail className="absolute left-6 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-primary transition-colors" size={20} />
              <input required type="email" placeholder="E-mail corporativo" className="w-full bg-transparent p-6 pl-16 rounded-[24px] text-white font-bold outline-none placeholder:text-white/20" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div className="h-[1px] bg-white/5 mx-6"></div>
            <div className="relative group">
              <Lock className="absolute left-6 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-primary transition-colors" size={20} />
              <input required type="password" placeholder="Senha de acesso" className="w-full bg-transparent p-6 pl-16 rounded-[24px] text-white font-bold outline-none placeholder:text-white/20" value={password} onChange={e => setPassword(e.target.value)} />
            </div>
          </div>

          {error && (
            <div className="bg-red-500/10 border border-red-500/20 p-4 rounded-2xl text-red-400 text-[10px] font-bold text-center animate-shake flex items-center gap-2 justify-center">
              <AlertCircle size={14} /> {error}
            </div>
          )}

          <button disabled={loading} className="w-full bg-primary hover:brightness-110 disabled:opacity-50 text-white p-6 rounded-[32px] font-black uppercase text-sm tracking-widest shadow-2xl shadow-primary/20 transition-all active:scale-95 flex items-center justify-center gap-3">
            {loading ? <Loader2 className="animate-spin" size={20} /> : <LogIn size={20} />}
            {loading ? 'Validando Acesso...' : 'Entrar no Sistema'}
          </button>
        </form>

        <div className="text-center pt-8 space-y-4">
           <p className="text-[9px] font-black uppercase text-white/20 tracking-[0.4em]">Core Authentication Node</p>
           
           <div className="flex items-center justify-center gap-2 opacity-30">
             <Database size={10} className={hasValidSupabaseConfig ? "text-emerald-400" : "text-red-400"} />
             <span className="text-[8px] font-bold uppercase tracking-widest">
               Supabase: {hasValidSupabaseConfig ? "Conectado" : "Desconectado"}
             </span>
           </div>
        </div>
      </div>
    </div>
  );
};
